export default "__VITE_ASSET__Bsko9W4___"